import React, { ChangeEventHandler } from "react";

import ErrorFormMessage from "../ErrorFormMessage";

type PropsType = {
  name: string;
  label?: string;
  id?: string;
  customClasses?: string;
  placeholder?: string;
  value?: string;
  required?: boolean;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  error?: string | boolean;
  options: [string, string][];
};

export default function Select({
  id,
  name,
  label,
  required = false,
  onChange,
  customClasses = "",
  placeholder,
  value,
  error,
  options,
}: PropsType) {
  let errorClasses = "";
  if (error) {
    errorClasses = "border-red-500 text-red-500";
  }

  return (
    <>
      <div
        className={`relative flex w-full flex-col gap-1 rounded-[4px] border-[1px] border-[#DEDDDB] bg-white bg-no-repeat px-3 py-3 leading-[18px] ${customClasses} ${errorClasses}`}
      >
        <label
          htmlFor={name}
          className={`font-barlowregular text-[12px] text-[#7F7F7F] ${errorClasses}`}
        >
          {label}
        </label>
        <select
          id={id}
          className="cursor-pointer appearance-none bg-white leading-normal placeholder:text-[#736F62] focus:outline-none"
          name={name}
          required={required}
          defaultValue={value}
          multiple={false}
          onChange={onChange}
        >
          {placeholder && (
            <option value="" disabled className="text-yellow">
              {placeholder}
            </option>
          )}
          {options.map((o) => (
            <option key={o[0]} value={o[0]}>
              {o[1]}
            </option>
          ))}
        </select>
        <div className={`absolute right-[15px] ${label?.length > 0 ? "top-[28px]" : "top-[22px]"}`}>
          <svg width="17" height="10" viewBox="0 0 17 10" fill="none">
            <path d="M1 1L8.5 9L16 1" stroke="#292929" />
          </svg>
        </div>
      </div>
      {error ? <ErrorFormMessage message={error} /> : null}
    </>
  );
}
